/**
 * Created by alex.shmaltsuev on 2016-04-06.
 */

import initialState from '../store/initialstate'
// import Constants from '../constants/auth'
import C_USER from  '../constants/user';


// export default (state = initialState().user, action = null) => {
//     switch(action.type){
//         case Constants.INIT_USER_SETTINGS:
//             state = state.set('userSettings',action.data);
//             break;
//     }
//     return state;
// }

export default (state = initialState().user, action = null) => {
    switch(action.type){
        case C_USER.SET_USER_CALCULATED_NAME:
            return state.set(C_USER.USER_CALCULATED_NAME, action.payload);
        case C_USER.SET_USER_NAME:
            return state.set(C_USER.USER_NAME, action.payload);
        case C_USER.SET_USER_PHOTO:
            return state.set(C_USER.USER_PHOTO, action.payload);
        case C_USER.SET_USER_PHOTO_UPDATED:
            return state.set(C_USER.USER_PHOTO_UPDATED, action.payload);
        case C_USER.SET_TIME_ZONE:
            return state.set(C_USER.TIME_ZONE, action.payload);
        case C_USER.SET_LOCALE:
            return state.set(C_USER.LOCALE, action.payload);
        case C_USER.SET_FIRST_DAY_OF_WEEK:
            return state.set(C_USER.FIRST_DAY_OF_WEEK, action.payload);
        case C_USER.SET_INPUT_DATE:
            return state.set(C_USER.INPUT_DATE, action.payload);

        case C_USER.SET_IS_GUEST:
            return state.set(C_USER.IS_GUEST, action.payload);
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./reducers/user.js